import { Model } from '@vuex-orm/core'

export default class Notifications extends Model {
  
    static entity = 'notifications'
    
    static primaryKey = 'id'

    static fields () {
        return {
            id: this.attr(''),
            title: this.attr(''),
            content:this.attr(''), 
            icon: this.attr(''),
            color: this.attr(''),
            time: this.attr(null), 
            ref: this.attr(null)
        }
    }  
}